import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';
const AbouttUs = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [categories,setCategories]=useState([]);

  const [handleedit,seteditData]=useState({
    id:null,
    select_city:'',
    home_configuration:'',
    kichen_shape:'',
    Cabinet_Material:'',
    Shutter_Material_Finish:'',
    Accessories:'',
    photo:''
  })

  const [showeditmodal,setshoweditmodal]=useState(false); 

  const [formData, setFormData] = useState({
    select_city:'',
    home_configuration:'',
    kichen_shape:'',
    Cabinet_Material:'',
    Shutter_Material_Finish:'',
    Accessories:'',
    photo:''

  });
  

  const fetchcategories=async()=>{
    try{
     const res=await axios.get('https://api.squareandangle.pranatigroup.in/api/admin/kitchen_calculator');
     console.log(res.data);
     setCategories(res.data);
    }catch(e){
      setError(e.response?.data?.message || 'Save failed');
    }
  }
  
  useEffect(() => {
   fetchcategories();
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleOpenModal = () => {
    setFormData({  select_city:'',
    home_configuration:'',
    kichen_shape:'',
    Cabinet_Material:'',
    Shutter_Material_Finish:'',
    Accessories:'',
    photo:'' });
    setShowModal(true);
    setError('');
  };
  const handlesave = async () => {
    setLoading(true);
    setError('');
    try {
      const data = new FormData();
      data.append('select_city', formData.select_city);
      data.append('home_configuration', formData.home_configuration);
      data.append('kichen_shape', formData.kichen_shape);
      data.append('Cabinet_Material', formData.Cabinet_Material);
      data.append('Shutter_Material_Finish', formData.Shutter_Material_Finish);
      data.append('Accessories', formData.Accessories);
      if (formData.photo instanceof File) {
        data.append('photo', formData.photo);
      }
      await axios.post('https://api.squareandangle.pranatigroup.in/api/admin/kitchen_calculator', data);
      setShowModal(false);
      setFormData({
        select_city: '',
        home_configuration: '',
        kichen_shape: '',
        Cabinet_Material: '',
        Shutter_Material_Finish: '',
        Accessories: '',
        photo: '',
      });
      fetchcategories();
    } catch (e) {
      setError(e.response?.data?.message || 'Save failed');
    } finally {
      setLoading(false);
    }
  };


   const handleeditin=(item)=>{
    seteditData({
    id:item.id,
    select_city:item.select_city,
    home_configuration:item.home_configuration,
    kichen_shape:item.kichen_shape,
    Cabinet_Material:item.Cabinet_Material,
    Shutter_Material_Finish:item.Shutter_Material_Finish,
    Accessories:item.Accessories,
    photo:item.photo
    
    })
    setshoweditmodal(true);
   }
 
   const handledelete=async(id)=>{
     setLoading(true);
    try{
         await axios.delete(`https://api.squareandangle.pranatigroup.in/api/admin/kitchen_calculator/${id}`);
      fetchcategories();
    }catch(e){
        setError(e.response?.data?.message || 'Save failed');
    }finally{
      setLoading(false);
    }
   }


   const handleupdatecat = async () => {
     setLoading(true);
     setError('');
    try {
       const data = new FormData();
       data.append('select_city', handleedit.select_city);
      data.append('home_configuration', handleedit.home_configuration);
      data.append('kichen_shape', handleedit.kichen_shape);
      data.append('Cabinet_Material', handleedit.Cabinet_Material);
      data.append('Shutter_Material_Finish', handleedit.Shutter_Material_Finish);
       data.append('Accessories', handleedit.Accessories);
      if (handleedit.photo instanceof File) {
        data.append('photo', handleedit.photo);
      }

       await axios.put(`https://api.squareandangle.pranatigroup.in/api/admin/kitchen_calculator/${handleedit.id}`, data);
      fetchcategories();
      setshoweditmodal(false);
      setLoading(false);
    }catch(e){
      setError(e.response?.data?.message || 'Update failed');
      setLoading(false);
      setshoweditmodal(false);
    }
   }

  const stylesD = {
    width: "169%",
    paddingRight: "1102px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto"
  };
  return (
    <>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="container-fluid" style={isMobile ? {} : stylesD}>
        <div className="d-flex justify-content-between align-items-center mb-3 px-2 w-100">
          <h3 className="m-0">About Us</h3>
          <button className="btn btn-primary" onClick={handleOpenModal}>+ Add New</button>
        </div>
        <div className="table-responsive w-100 p-0">
          <table className="table table-bordered table-striped bg-white w-100 m-0">
            <thead className="thead-dark">
              <tr>
                <th>Serial No</th>
                <th>Select City</th>
                <th>Home Configuration</th>
                <th>Kitchen Shape</th>
                <th>Cabinet Material</th>
                <th>Shutter Material Finish</th>
                <th>Accessories</th>
                <th>Photo</th>

             <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
            
                {
                categories.length>0 ?(
                
                categories.map((item, index) => (
                <tr key={item.id}>
               
                  <td>{index +1}</td>
                  <td>{item.select_city}</td>
                  <td>{item.home_configuration}</td>
                   <td>{item.kichen_shape}</td>
                   <td>{item.Cabinet_Material}</td>
                  <td>{item.Shutter_Material_Finish}</td>
                  <td>{item.Accessories}</td>
                   <td><img src={uploadUrl(item.photo)} alt="pranati website" width="100"/></td>
                   <td className="text-center">
                    <button className="btn btn-sm btn-outline-primary mr-2" onClick={()=>handleeditin(item)}>Edit</button>
                    <button className="btn btn-sm btn-outline-danger" onClick={()=>handledelete(item.id)}>Delete</button>
                  </td>
                </tr>
              ))
                ):(
               <tr>

                <td colSpan="9" className="text-center text-muted">
                  No Company Data Found
                </td>
               </tr>

                )}
            </tbody>

            
           
          </table>
        </div>
      </div>
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Category</h5>
                <button 
                  className="close" 
                  style={{ background: 'transparent', border: 'none', fontSize: '1.5rem' }} 
                  onClick={() => setShowModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
               
                 <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="input city "
                  value={formData.select_city} 
                  onChange={(e) => setFormData({ ...formData, select_city: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="home configuration"
                  value={formData.home_configuration} 
                  onChange={(e) => setFormData({ ...formData, home_configuration: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="kitchen Shape"
                  value={formData.kichen_shape} 
                  onChange={(e) => setFormData({ ...formData, kichen_shape: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Cabinet Material"
                  value={formData.Cabinet_Material } 
                  onChange={(e) => setFormData({ ...formData, Cabinet_Material: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Shutter Material Finish"
                  value={formData.Shutter_Material_Finish} 
                  onChange={(e) => setFormData({ ...formData, Shutter_Material_Finish: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Accessories"
                  value={formData.Accessories	} 
                  onChange={(e) => setFormData({ ...formData, Accessories	: e.target.value })}
                />
                <input 
                  type="file"
                  className="form-control mb-2"
                  placeholder="Filename"
                  onChange={(e) => setFormData({ ...formData, photo: e.target.files[0] })}
                />
                
               
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handlesave} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}



      {showeditmodal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Category</h5>
                <button 
                  className="close" 
                  style={{ background: 'transparent', border: 'none', fontSize: '1.5rem' }} 
                  onClick={() => setshoweditmodal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
               
                   <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="input city "
                  value={handleedit.select_city} 
                  onChange={(e) => seteditData({ ...handleedit, select_city: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="home configuration"
                  value={handleedit.home_configuration} 
                  onChange={(e) => seteditData({ ...handleedit, home_configuration: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="kitchen Shape"
                  value={handleedit.kichen_shape} 
                  onChange={(e) => seteditData({ ...handleedit, kichen_shape: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Cabinet Material"
                  value={handleedit.Cabinet_Material } 
                  onChange={(e) => seteditData({ ...handleedit, Cabinet_Material: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Shutter Material Finish"
                  value={handleedit.Shutter_Material_Finish} 
                  onChange={(e) => seteditData({ ...handleedit, Shutter_Material_Finish: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Accessories"
                  value={handleedit.Accessories	} 
                  onChange={(e) => seteditData({ ...handleedit, Accessories	: e.target.value })}
                />
                <input 
                  type="file"
                  className="form-control mb-2"
                  placeholder="Filename"
                  onChange={(e) => seteditData({ ...handleedit, photo: e.target.files[0] })}
                />
                
               
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setshoweditmodal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleupdatecat} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default AbouttUs;